import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';


@Component({
  selector: 'formly-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  imports: [MatIconModule],
  template: `
  <div class="flex flex-col mt-4 pt-6 border-t space-y-8">
    <div class="flex sm:items-center">
      <div class="flex sm:items-start justify-between space-x-2">
        <p class="leading-6 tracking-normal text-black md:text-lg">{{props.label}}</p>
      </div>
       <div class="ml-4 leading-normal sm:text-lg text-center tracking-tight text-black ">
          <p>{{field.formControl.value}}</p>
       </div>
    </div>
  </div>`
})
export class PresentataReadComponent extends FieldType<FieldTypeConfig> {

}